import React from "react";

const TermCondition = () => {
  return (
    <>
      <div class="middle-section">
        <div class="container">
          <div class="cms-section">
            <div class="heading">
              <h2>Terms of Use</h2>
            </div>
            <div class="whitebox">
              <p>
                <strong>MyClubtap - Terms of Service</strong>
              </p>
              <p>
                The following terms of service are applicable to everyone using
                MyClubtap fantasy sport platform. By using our platform, you
                agree to be bound by these terms of platform service, conditions
                and privacy policy which combine to constitute the overall terms
                of our services.
              </p>
              <p>Version dated July 18 2023</p>
              <p>
                The Terms of Service, Terms and Conditions and Privacy Policy
                are a legal agreement between you (&quot;You), the user of this
                website myclubtap.com and MyClubtap (&quot;Club Fantasy Square
                Pty Ltd&quot;), the owner and right holder of the website and
                provider of the Platform. We recommend that You read them
                carefully.
              </p>
              <p>
                MyClubtap may revise these terms and conditions from time to
                time, with clear update date provided on this website page. We
                recommend you review the platform periodically and take note of
                any updates. If You do not agree with the set terms, conditions,
                and privacy policy, you should not or immediately cease your
                access of the platform. All use of our platform is governed by
                the set terms, conditions, and the listed privacy policy.
              </p>
              <br></br>
              <p>
                <strong>
                  Our Contract: Platform Service for Clubs and Leagues
                </strong>
              </p>
              <p>
                MyClubtap provides sports clubs and leagues with the platform
                and infrastructure to set up and manage an online fantasy sport
                league of their own. The platform is free to join and set- up
                for every club and league, with access to all admin features of
                the platform. Game activation requires the account holder to
                opt-in for one of the pricing plans (Starter Plan or Partner
                Plan), with both plans allowing account holders’ access to all
                features.
              </p>
              <br></br>
              <p>
                <strong>Starter Plan</strong>
              </p>
              <p>
                Is priced at $99 (AUD) for game activation. Special features and
                services are available at a charge, such as scores update
                service or game pass fees collection.
              </p>
              <p>
                Starter Plan fee is for the duration of 1 game (season) only.
                Should a club wish to run another fantasy game subsequently, a
                separate game activation fees must be made accordingly.
              </p>
              <p>
                Club or League can opt-in to use the feature to set a Game Pass
                fees for the game, with the collection of Game Pass fee done by
                MyClubtap on behalf of the Club or League.
              </p>
              <p>
                In cases where MyClubtap collects Game Pass fee money on behalf
                of a Club (using the Starter Plan), a 15% processing fee will be
                payable, which is used to cover transaction and administration
                costs. The remaining 85% will be transferred to the
                individual(s) / administrator(s) responsible for setting up and
                maintaining the fantasy game for their respective Club or League
                (Game Administrator) on request, who are required to contact the
                MyClubtap support team and Club or League funds will be
                dispatched within 15 days of such notification and, where
                applicable, payable by way of bank transfer.
              </p>
              <br></br>
              <p>
                <strong>Partner Plan</strong>
              </p>
              <p>Is available for clubs in Australia only.</p>
              <p>
                It allows a Club or League to Partner with MyClubtap as an
                official fantasy partner of the Club or League.
              </p>
              <p>
                Partnership includes recognition by the Club or League of
                MyClubtap as its official fantasy partner, with MyClubtap taking
                care of all game score updates, access to all admin platform
                features to the Club or League and enables a Club or League to
                set the Game Pass fees for the game, with the collection of Game
                Pass fee done by MyClubtap on behalf of the Club or League.
              </p>
              <p>
                In cases where MyClubtap collects Game Pass fee money on behalf
                of a Club, a 40% processing fee will be payable, which is used
                to cover transaction, administration, and scorer service costs.
                The remaining 60% will be transferred to the individual(s) /
                administrator(s) responsible for setting up and maintaining the
                fantasy game for their respective Club or League (Game
                Administrator) on request.
              </p>
              <br></br>
              <p>
                <strong>Game Data Validity</strong>
              </p>
              <p>
                All fantasy games are active for the duration of the game
                (season) as set in the start and end date/time of Round 1 by the
                Game Administrator, with the game data being cleared 45-days
                after at the end of the game or as determined by MyClubtap, to
                perform a reset for the next season of the game. All empty
                fantasy games with no activity within the first 45 days since
                the date of signup are removed from the platform.
              </p>
              <p>
                All fantasy games can be removed in the following year if no
                confirmation has been received from the respective Clubs and
                League of their willingness to continue using the platform,
                within 45-days after the end date of their current game.
              </p>
              <br></br>
              <p>
                <strong>Fundraising For Clubs or Leagues</strong>
              </p>
              <ol>
                <li>
                  <p>
                    Wherever applicable, Clubs or Leagues could use their
                    fantasy game as a fundraiser. Any relevant collection of
                    Game Pass fee on behalf of a Club or League is for
                    collection of funds purposes only, which incurs a
                    transaction and processing fee, with the remainder collected
                    fee transferred to the individual(s) / administrator(s)
                    responsible for setting up and maintaining the fantasy game
                    for their respective Club or League (Game Administrator) on
                    request.
                  </p>
                </li>
                <li>
                  <p>
                    MyClubtap does not enforce a requirement of setup of a Game
                    Pass fee on the Clubs or Leagues, who are solely responsible
                    for the setup of any such fees.
                  </p>
                </li>
                <li>
                  <p>
                    MyClubtap provides a ready-to-use fantasy platform for
                    sports Clubs and Leagues, which can be fully managed and run
                    by the Club or League. By using our platform, you
                    acknowledge and agree that MyClubtap is not responsible for
                    any failure of the platform to store your data, corruption
                    and/or loss of any data, information and/or any other
                    content. You permit to grant MyClubtap the non-exclusive,
                    worldwide, royalty free rights to an open fantasy game of
                    the clubs on the platform.
                  </p>
                </li>
              </ol>
              <p>
                MyClubtap reserves the right to disclose any data or information
                in so far as it is required to uphold MyClubtap terms, abide by
                the law, comply with any court orders, complying with the law,
                defending itself in legal proceedings and in defence of national
                or public security matters.
              </p>
              <br></br>
              <p>
                <strong>Not Allowed on MyClubtap</strong>
              </p>
              <p>
                By using our platform (MyClubtap), you (Clubs or Leagues) agree
                that prizes will not be offered on our platform. MyClubtap is
                not a gambling or wagering platform (website).
              </p>
              <br></br>
              <p>
                <strong>Your account and personal information</strong>
              </p>
              <ol>
                <li>
                  <p>
                    When you visit Our Website, you accept responsibility for
                    any action done by any person using your name, account or
                    password. You should take all necessary steps to ensure that
                    the password is kept confidential and secure and should
                    inform us immediately if you have any reason to believe that
                    your password has become known to anyone else, or if the
                    password is being, or is likely to be, used in an
                    unauthorised manner.
                  </p>
                </li>
                <li>
                  <p>
                    You agree that you have provided accurate, up to date, and
                    complete information about yourself. We are not responsible
                    for any errors made as a result of such information being
                    inaccurate
                  </p>
                </li>
                <li>
                  <p>
                    You agree to notify us of any changes in your information
                    immediately it occurs. If you do not do so, we may terminate
                    your account.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>MyClubtap PRO Membership (For Members)</strong>
              </p>
              <ol>
                <li>
                  <p>
                    Is available as an OPT-IN feature for all Members (Users) of
                    the platform.
                  </p>
                </li>
                <li>
                  <p>
                    Is priced at $9.99 with a validity of 1-year (annual) from
                    the date of activation.
                  </p>
                </li>
                <li>
                  <p>
                    It provides a PRO Member with access to additional dataset
                    across all games the Member may join or access on the
                    platform and help boost the members decision making, to go
                    along with access to more PRO member features.
                  </p>
                </li>
                <li>
                  <p>
                    No Member of the platform is enforced to purchase MyClubtap
                    PRO Membership, with each Member allowed free access to
                    basic set of features, pending any terms and conditions of
                    the owners of the Game (Club or League).
                  </p>
                </li>
                <li>
                  <p>
                    Basic payment for use of MyClubtap platform is $0 and any
                    fundraiser fees raised on behalf of the a Club or League
                    game is done for the respective Club or League, who are
                    solely responsible for Game Pass fee charged.
                  </p>
                </li>
                <li>
                  <p>
                    Members can cancel a PRO Membership within 7-days of
                    purchase of PRO Membership. See our refund policy for more
                    details.
                  </p>
                </li>
                <li>
                  <p>
                    You do not have to take any action for this to apply. By
                    accepting these terms and conditions, you do instruct us to
                    start immediately / give you immediate access / provide the
                    MyClubtap platform. You know that by doing so, you may not
                    be entitled to a refund.
                  </p>
                </li>
                <li>
                  <p>
                    Other than the limitation set out above access to MyClubtap
                    platform is non-refundable and non-transferable.
                  </p>
                </li>
                <li>
                  <p>
                    Apart from your cancellation right, termination of Service
                    will be regulated by this contract set out in termination
                    para below.
                  </p>
                </li>
                <li>
                  <p>
                    We reserve the right to modify the MyClubtap platform and to
                    change the terms and conditions of this agreement at any
                    time, without notice. Your continued use of the MyClubtap
                    platform after such modifications shall be deemed an
                    acceptance by you to be bound by the terms of the modified
                    agreement. The terms that apply to you are those Posted here
                    on Our Website on the day you join as a member.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>Security of your credit card</strong>
              </p>
              <p>We take care to make Our Website safe for you to use.</p>
              <ol>
                <li>
                  <p>
                    Card payments for MyClubtap PRO Membership, Admin Account
                    Activation, Game Pass Fees are not processed through pages
                    controlled by us. We use one or more online payment service
                    providers who will encrypt your card or bank account details
                    in a secure environment.
                  </p>
                </li>
                <li>
                  <p>
                    If you have asked us to remember your credit card details in
                    readiness for your next purchase or subscription, we will
                    securely store your payment details on our systems. These
                    details will be fully encrypted and only used to process
                    your automatic payments or other transactions which you have
                    initiated.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>How we handle Your Content</strong>
              </p>
              <ol>
                <li>
                  <p>
                    Our privacy policy is strong and precise. It complies fully
                    with current law.
                  </p>
                </li>
                <li>
                  <p>
                    If you Post Content to any public area of Our Website it
                    becomes available in the public domain. We have no control
                    who sees it or what anyone does with it.
                  </p>
                </li>
                <li>
                  <p>
                    Even if access to your text is behind a user registration it
                    remains effectively in the public domain because someone has
                    only to register and log in, to access it. You should
                    therefore avoid Posting unnecessary confidential
                    information.
                  </p>
                </li>
                <li>
                  <p>
                    We need the freedom to be able to publicise our Services and
                    your own use of them. You therefore now irrevocably grant us
                    the right and licence to edit, copy, publish, distribute,
                    translate and otherwise use any Content that you place on
                    Our Website, in public domains and in any medium. You
                    represent and warrant that you are authorised to grant all
                    such rights.
                  </p>
                </li>
                <li>
                  <p>
                    We will use that licence only for commercial purposes of the
                    business of Our Website and will stop using it after a
                    commercially reasonable period of time.
                  </p>
                </li>
                <li>
                  <p>
                    You agree to waive your right to be identified as the author
                    and your right to object to derogatory treatment of your
                    work as provided in the Copyright Act1968.
                  </p>
                </li>
                <li>
                  <p>
                    You now irrevocably authorise us to publish feedback,
                    comments and ratings about your activity through Our
                    Website, even though it may be defamatory or critical.
                  </p>
                </li>
                <li>
                  <p>
                    Posting content of any sort does not change your ownership
                    of the copyright in it. We have no claim over it and we will
                    not protect your rights for you.
                  </p>
                </li>
                <li>
                  <p>
                    You understand that you are personally responsible for your
                    breach of someone else’s intellectual property rights,
                    defamation, or any law, which may occur as a result of any
                    Content having been Posted by you.
                  </p>
                </li>
                <li>
                  <p>
                    You accept all risk and responsibility for determining
                    whether any Content is in the public domain and not
                    confidential.
                  </p>
                </li>
                <li>
                  <p>
                    Please notify us of any security breach or unauthorised use
                    of your account.
                  </p>
                </li>
                <li>
                  <p>
                    We do not solicit ideas or text for improvement of our
                    Service, but if you do send to us material of any sort, you
                    are deemed to have granted us a licence to use it.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>
                  Restrictions on what you may Post to Our Website
                </strong>
              </p>
              <p>
                We invite you to Post Content to Our Website in several ways and
                for different purposes. We have to regulate your use of Our
                Website to protect our business and our staff, to protect other
                users of Our Website and to comply with the law. These
                provisions apply to all users of Our Website.
              </p>
              <p>
                We do not undertake to moderate or check every item Posted, but
                we do protect our business vigorously. If we believe Content
                Posted breaches the law, we shall cooperate fully with the law
                enforcement authorities in whatever ways we can.
              </p>
              <p>
                You agree that you will not use or allow anyone else to use Our
                Website to Post Content or undertake any activity which is or
                may:
              </p>
              <ol>
                <li>
                  <p>
                    be unlawful, or tend to incite another person to commit a
                    crime;
                  </p>
                </li>
                <li>
                  <p>consist in commercial audio, video or music files;</p>
                </li>
                <li>
                  <p>
                    be obscene, offensive, threatening, violent, malicious or
                    defamatory;
                  </p>
                </li>
                <li>
                  <p>be sexually explicit or pornographic;</p>
                </li>
                <li>
                  <p>
                    be likely to deceive any person or be used to impersonate
                    any person, or to misrepresent your identity, age or
                    affiliation with any person;
                  </p>
                </li>
                <li>
                  <p>
                    use a Posting to solicit responses unconnected with the
                    purpose of Our Website or the terms proposed by this
                    agreement;
                  </p>
                </li>
                <li>
                  <p>
                    request or collect passwords or other personal information
                    from another user without his permission, nor Post any
                    unnecessary personal information about yourself;
                  </p>
                </li>
                <li>
                  <p>
                    be used to sell any goods or services or for any other
                    commercial use not intended by us, for you or for any other
                    person. Examples are: sending private messages with a
                    commercial purpose, or collecting information with the
                    intention of passing it to a third party for his commercial
                    use;
                  </p>
                </li>
                <li>
                  <p>
                    include anything other than words (i.e. you will not include
                    any symbols or photographs) except for a photograph of
                    yourself in your profile in such place as we designate;
                  </p>
                </li>
                <li>
                  <p>
                    facilitate the provision of unauthorised copies of another
                    person's copyright work;
                  </p>
                </li>
                <li>
                  <p>
                    link to any of the material specified in this paragraph;
                  </p>
                </li>
                <li>
                  <p>
                    use distribution lists that include people who have not
                    given specific permission to be included in such
                    distribution process;
                  </p>
                </li>
                <li>
                  <p>
                    send age-inappropriate communications or Content to anyone
                    under the age of 18.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>Your Posting: restricted content</strong>
              </p>
              <p>
                In connection with the restrictions set out below, we may refuse
                or edit or remove a Posting which does not comply with these
                terms.
              </p>
              <p>
                In addition to the restrictions set out above, a Posting must
                not contain:
              </p>
              <ol>
                <li>
                  <p>
                    hyperlinks, other than those specifically authorised by us;
                  </p>
                </li>
                <li>
                  <p>
                    keywords or words repeated, which are irrelevant to the
                    Content Posted.
                  </p>
                </li>
                <li>
                  <p>
                    the name, logo or trademark of any organisation other than
                    yours.
                  </p>
                </li>
                <li>
                  <p>inaccurate, false, or misleading information.</p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>Removal of offensive Content</strong>
              </p>
              <ol>
                <li>
                  <p>
                    For the avoidance of doubt, this paragraph is addressed to
                    any person who comes to Our Website for any purpose.
                  </p>
                </li>
                <li>
                  <p>
                    We are under no obligation to monitor or record the activity
                    of any user of Our Website for any purpose, nor do we assume
                    any responsibility to monitor or police internet-related
                    activities. However, we may do so without notice to you and
                    without giving you a reason.
                  </p>
                </li>
                <li>
                  <p>
                    If you are offended by any Content, the following procedure
                    applies:
                  </p>

                  <ol>
                    <li>
                      <p>
                        your claim or complaint must be submitted to us in the
                        form available on Our Website, or contain the same
                        information as that requested in our form. It must be
                        sent to us by post or email.
                      </p>
                    </li>
                    <li>
                      <p>
                        we shall remove the offending Content as soon as we are
                        reasonably able;
                      </p>
                    </li>
                    <li>
                      <p>
                        after we receive notice of a claim or complaint, we
                        shall investigate so far as we alone decide;
                      </p>
                    </li>
                    <li>
                      <p>
                        we may reinstate the Content about which you have
                        complained or we may not.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    In respect of any complaint made by you or any person on
                    your behalf, whether using our form of complaint or not, you
                    now irrevocably grant to us a licence to publish the
                    complaint and all ensuing correspondence and communication,
                    without limit.
                  </p>
                </li>
                <li>
                  <p>
                    You now agree that if any complaint is made by you
                    frivolously or vexatiously you will repay us the cost of our
                    investigation including legal fees, if any.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>Security of Our Website</strong>
              </p>
              <p>
                If you violate Our Website we shall take legal action against
                you.
              </p>
              <p>
                You now agree that you will not, and will not allow any other
                person to:
              </p>
              <ol>
                <li>
                  <p>
                    modify, copy, or cause damage or unintended effect to any
                    portion of Our Website, or any software used within it.
                  </p>
                </li>
                <li>
                  <p>
                    link to Our Website in any way that would cause the
                    appearance or presentation of the site to be different from
                    what would be seen by a user who accessed the site by typing
                    the URL into a standard browser;
                  </p>
                </li>
                <li>
                  <p>
                    download any part of Our Website, without our express
                    written consent;
                  </p>
                </li>
                <li>
                  <p>
                    collect or use any product listings, descriptions, or
                    prices;
                  </p>
                </li>
                <li>
                  <p>
                    collect or use any information obtained from or about Our
                    Website or the Content except as intended by this agreement;
                  </p>
                </li>
                <li>
                  <p>
                    aggregate, copy or duplicate in any manner any of the
                    Content or information available from Our Website, other
                    than as permitted by this agreement or as is reasonably
                    necessary for your use of the Services;
                  </p>
                </li>
                <li>
                  <p>
                    share with a third party any login credentials to Our
                    Website;
                  </p>
                </li>
                <li>
                  <p>
                    Despite the above terms, we now grant a licence to you to:
                  </p>

                  <ol>
                    <li>
                      <p>
                        create a hyperlink to Our Website for the purpose of
                        promoting an interest common to both of us. You can do
                        this without specific permission. This licence is
                        conditional upon your not portraying us or any product
                        or service in a false, misleading, derogatory, or
                        otherwise offensive manner. You may not use any logo or
                        other proprietary graphic or trademark of ours as part
                        of the link without our express written consent.
                      </p>
                    </li>
                    <li>
                      <p>
                        you may copy the text of any page for your personal use
                        in connection with the purpose of Our Website or a
                        Service we provide.
                      </p>
                    </li>
                  </ol>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>Termination</strong>
              </p>
              <ol>
                <li>
                  <p>
                    You may terminate this agreement at any time, for any
                    reason, with immediate effect. You may terminate the
                    agreement either by sending notice to us by post or email,
                    or by completing the form on Our Website and submitting it.
                    We reserve the right to check the validity of any request to
                    terminate membership
                  </p>
                </li>
                <li>
                  <p>
                    We may terminate this agreement at any time, for any reason,
                    with immediate effect by sending you notice to that effect
                    by post or email.
                  </p>
                </li>
                <li>
                  <p>
                    If you terminate, we shall not have any residual liability
                    or obligation to you.
                  </p>
                </li>
                <li>
                  <p>
                    Termination by either party shall have the following
                    effects:
                  </p>

                  <ol>
                    <li>
                      <p>
                        your right to use the MyClubtap Service immediately
                        ceases;
                      </p>
                    </li>
                    <li>
                      <p>
                        we are under no obligation to forward any unread or
                        unsent messages to you or any third party;
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    Whether we or you terminate this agreement, you are not
                    entitled to any refund of any clubs premium leaderboard
                    joining fee.
                  </p>
                </li>
                <li>
                  <p>
                    At any time if we decide in our absolute discretion that you
                    have failed to comply with any of the terms of this
                    agreement, we reserve the right to terminate any and all
                    parts of the MyClubtap Service without refunding to you any
                    fees paid.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>
                  Your claims: defamation and intellectual property
                </strong>
              </p>
              <p>
                It is not possible for MyClubtap, nor within scope of our
                policy, to read and assess every piece of Content Posted by
                others on Our Website. Accordingly, we operate on the basis that
                we remove any offending material as soon as we are reasonably
                able, after we receive notice of a claim or complaint. This
                procedure is subject to:
              </p>
              <ol>
                <li>
                  <p>
                    The claim or complaint being submitted to us in the form
                    available on Our Website, or containing the same information
                    as that requested in our form.
                  </p>
                </li>
                <li>
                  <p>
                    The claim or form being submitted to us by post or through
                    the web mail contact system on Our Website.
                  </p>
                </li>
                <li>
                  <p>Our follow-up investigation of your complaint.</p>
                </li>
                <li>
                  <p>
                    In respect of any complaint made by you or any person on
                    your behalf, whether using our form of complaint or not, you
                    now irrevocably grant us a licence to publish the complaint
                    and all ensuing correspondence and communication, without
                    limit.
                  </p>
                </li>
                <li>
                  <p>
                    You now agree that if any complaint is made by you
                    frivolously or vexatiously you will repay us the cost of our
                    investigation including legal fees, if any.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>
                  Copyright and other intellectual property rights
                </strong>
              </p>
              <ol>
                <li>
                  <p>
                    All Content on Our Website, for example page text, graphics,
                    logos, images, audio clips, digital downloads, data
                    compilations, and software, is the property of either us or
                    our affiliates or partners. It is all protected by
                    international copyright laws.
                  </p>
                </li>
                <li>
                  <p>
                    You may not copy, or in any way exploit any of the Content,
                    except as is expressly permitted in this agreement or with
                    our written consent. For the sake of good order you should
                    note that copyright exists in compilations and graphic
                    images, shapes and styles, as well as in raw text.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>Interruption to the MyClubtap Service</strong>
              </p>
              <ol>
                <li>
                  <p>
                    We give no warranty that the MyClubtap Service will be
                    satisfactory to you.
                  </p>
                </li>
                <li>
                  <p>
                    We will do all we can to maintain access to Our Website, but
                    it may be necessary for us to suspend all or part of our
                    Membership Service for repairs, maintenance or other reason.
                    We may do so without telling you first.
                  </p>
                </li>
                <li>
                  <p>
                    You acknowledge that MyClubtap Service may also be
                    interrupted for reasons beyond our control.
                  </p>
                </li>
                <li>
                  <p>
                    You agree that we are not liable to you for any loss whether
                    foreseeable or not, arising as a result of interruption to
                    MyClubtap Service.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>Indemnity</strong>
              </p>
              <p>
                You agree to indemnify us against any claim or demand, including
                reasonable lawyers’ fees, made by any third party due to or
                arising out of:
              </p>
              <ol>
                <li>
                  <p>your use of the MyClubtap Service;</p>
                </li>
                <li>
                  <p>the breach or violation of this agreement by you;</p>
                </li>
                <li>
                  <p>
                    the infringement by you, or by any other Member of the
                    MyClubtap Service using your computer, of any intellectual
                    property or other right of any person or entity;
                  </p>
                </li>
                <li>
                  <p>your failure to comply with any law;</p>
                </li>
                <li>
                  <p>
                    a contractual claim arising from your use of our Membership
                    Services and purchase of a Product.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>
                  Disclaimers about the MyClubtap Membership Service
                </strong>
              </p>
              <ol>
                <li>
                  <p>
                    Your use of the MyClubtap Membership Service is without any
                    warranty or guarantee.
                  </p>
                </li>
                <li>
                  <p>
                    Where we provide a Service without specific charge, then it
                    is deemed to be provided free of charge, and not to be
                    associated with any other service for which a charge is
                    made. Accordingly, there is neither contractual nor other
                    obligation upon us in respect of any such service.
                  </p>
                </li>
                <li>
                  <p>
                    We or our Content suppliers may make improvements or changes
                    to Our Website, the Content, or to any of the Products and
                    services described on the website, at any time and without
                    notice to you.
                  </p>
                </li>
                <li>
                  <p>
                    You are advised that Content may include technical
                    inaccuracies or typographical errors.
                  </p>
                </li>
                <li>
                  <p>
                    Our Website contains links to other websites. We have
                    neither power nor control over any such website. You
                    acknowledge and agree that we shall not be liable in any way
                    for the content of any such linked website, nor for any loss
                    or damage arising from your use of any such website.
                  </p>
                </li>
                <li>
                  <p>
                    We are not liable in any circumstances for special, indirect
                    or consequential damages or any damages whatsoever resulting
                    from loss of use, loss of data or loss of revenues or
                    profits, whether in an action of contract, negligence or
                    otherwise, arising out of or in connection with your use of
                    Our Website.
                  </p>
                </li>
                <li>
                  <p>
                    The MyClubtap Website Services are provided “as is”. We make
                    no representation or warranty of any kind, express or
                    implied, including, without limitation, any warranty that
                    either of them will be:
                  </p>

                  <ol>
                    <li>
                      <p>of satisfactory quality;</p>
                    </li>
                    <li>
                      <p>fit for a particular purpose;</p>
                    </li>
                    <li>
                      <p>
                        available or accessible, without interruption, or
                        without error.
                      </p>
                    </li>
                  </ol>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>Disclaimers about Partner Products</strong>
              </p>
              <ol>
                <li>
                  <p>
                    All of the Content on Our Website relating to any Product
                    has been provided by a Partner sponsor. We do not accept
                    responsibility for the accuracy of any claim or
                    advertisement.
                  </p>
                </li>
                <li>
                  <p>
                    We make no representation, warranty or other provision with
                    regard to the Products and you acknowledge that you do not
                    rely on any made by us, but solely on your contract with a
                    Seller.
                  </p>
                </li>
                <li>
                  <p>
                    So far as concerns Products you buy through Our Website, we
                    are not liable for:
                  </p>

                  <ol>
                    <li>
                      <p>
                        any Product complying with the requirement of any law or
                        being available;
                      </p>
                    </li>
                    <li>
                      <p>the Seller performing his contract.</p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    We give no warranty, representation or undertaking whatever
                    as to the continuing business of a Seller or that any
                    Product sold by a Seller will work or be useful or will be
                    suitable for you.
                  </p>
                </li>
                <li>
                  <p>
                    You now expressly release MyClubtap from any and all claims
                    and liability known and unknown, arising in any way from a
                    dispute between you and a Seller.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>Miscellaneous matters</strong>
              </p>
              <ol>
                <li>
                  <p>
                    You undertake to provide us your current land address,
                    e-mail address, telephone number if you subscribe to our
                    Membership Service, as often as they are changed together
                    with all information that we may require to enable us to
                    fulfil our obligations under this contract.
                  </p>
                </li>
                <li>
                  <p>
                    So far as any time, date or period is mentioned in this
                    agreement, time shall be of the essence.
                  </p>
                </li>
                <li>
                  <p>
                    If any term or provision of this agreement is at any time
                    held by any jurisdiction to be void, invalid or
                    unenforceable, then it shall be treated as changed or
                    reduced, only to the extent minimally necessary to bring it
                    within the laws of that jurisdiction and to prevent it from
                    being void and it shall be binding in that changed or
                    reduced form. Subject to that, each provision shall be
                    interpreted as severable and shall not in any way affect any
                    other of these terms.
                  </p>
                </li>
                <li>
                  <p>
                    For the purposes of the Privacy Act 1988 as amended you
                    consent to the processing of your personal data (in manual,
                    electronic or any other form) relevant to this agreement, by
                    us and/or any agent or third party nominated by us and bound
                    by a duty of confidentiality. Processing includes but is not
                    limited to obtaining, recording, using and holding data and
                    includes the transfer of data to any country.
                  </p>
                </li>
                <li>
                  <p>
                    If you are in breach of any term of this agreement, we may:
                  </p>

                  <ol>
                    <li>
                      <p>
                        publish all text and Content relating to the claimed
                        breach, including your name and email address and all
                        correspondence between us and our respective advisers;
                        and you now irrevocably give your consent to such
                        publication.
                      </p>
                    </li>
                    <li>
                      <p>
                        terminate your account and refuse access to Our Website;
                      </p>
                    </li>
                    <li>
                      <p>
                        remove or edit Content, or cancel any order at our
                        discretion;
                      </p>
                    </li>
                    <li>
                      <p>issue a claim in any court.</p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    Any obligation in this agreement intended to continue to
                    have effect after termination or completion shall so
                    continue.
                  </p>
                </li>
                <li>
                  <p>
                    No failure or delay by any party to exercise any right,
                    power or remedy will operate as a waiver of it nor indicate
                    any intention to reduce that or any other right in the
                    future.
                  </p>
                </li>
                <li>
                  <p>
                    When you visit Our Website or send messages to us by email,
                    you are communicating with us electronically. We communicate
                    with you by e-mail or by posting notices on Our Website. You
                    agree that all our electronic communications satisfy any
                    legal requirement that such communications be in writing.
                  </p>
                </li>
                <li>
                  <p>
                    Any communication to be served on either of us by the other
                    shall be delivered by hand or sent by first class post or
                    recorded delivery or by e-mail. It shall be deemed to have
                    been delivered:
                  </p>

                  <ol>
                    <li>
                      <p>if delivered by hand: on the day of delivery;</p>
                    </li>
                    <li>
                      <p>
                        if sent by post to the correct address: within 72 hours
                        of posting;
                      </p>
                    </li>
                    <li>
                      <p>
                        If sent by e-mail to the address from which the
                        receiving party has last sent e-mail: within 24 hours if
                        no notice of non-receipt has been received by the
                        sender.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    In the event of a dispute between us, then, if we so ask,
                    you undertake to attempt to settle the dispute by engaging
                    in good faith with us in a process of mediation before
                    commencing arbitration or litigation.
                  </p>
                </li>
                <li>
                  <p>
                    This agreement does not give any right to any third party.
                  </p>
                </li>
                <li>
                  <p>
                    We shall not be liable for any failure or delay in our
                    performance of this agreement which is caused by
                    circumstances beyond our reasonable control, including any
                    labour dispute.
                  </p>
                </li>
                <li>
                  <p>
                    In the event of any conflict between any term of this
                    agreement and the provisions of the constitution of a
                    limited company or any comparable document intended to
                    regulate any other corporate or collective body, then the
                    terms of this agreement shall prevail.
                  </p>
                </li>
                <li>
                  <p>
                    This agreement shall not be governed by the United Nations
                    Convention on Contracts for the International Sale of Goods,
                    the application of which is hereby expressly excluded.
                  </p>
                </li>
                <li>
                  <p>
                    The validity, construction and performance of this agreement
                    shall be governed by the laws of State of Victoria,
                    Australia.
                  </p>
                </li>
              </ol>
              <br></br>
              {/* Condition of use section start here */}
              <p>
                <strong>MyClubtap-Conditions of Use</strong>
              </p>
              <br></br>
              <p>
                <strong>Introduction</strong>
              </p>
              <p>
                Welcome to the internet website of MyClubtap, which includes
                myclubtap.com.
              </p>
              <p>
                The website is owned by Club Fantasy Square Pty Ltd and operated
                under our business name MyClubtap, a company registered in
                Australia, with its registered office at Talara Close,
                Springvale, VIC 3171 Australia, under ACN 619183710.
              </p>
              <p>
                PLEASE READ THESE TERMS OF USE CAREFULLY BEFORE USING THIS
                WEBSITE
              </p>
              <p>
                By using this website or by clicking a box which states that you
                accept or agree to these terms, you indicate your agreement to
                these terms. If you do not agree with the mentioned terms of
                use, please do not proceed to use this website.
              </p>
              <p>
                You understand and acknowledge that laid terms of use are
                supported by sound and valued thoughts, competence of which is
                hereby acknowledged (which includes, but is not limited to your
                use of this website, access to available content, information
                and/or the possibility of our use of display of your submissions
                and/or the publicity and promotion from our side using your
                submissions).
              </p>
              <br></br>
              <p>
                <strong>Using the Website and Content</strong>
              </p>
              <p>
                This website is available for your personal use only. You shall
                not use this website for commercial purposes or in any manner
                that is unlawful, or harms us or any other person or group, as
                determined in our sole discretion.
              </p>
              <p>
                In our sole discretion, we can make changes to this website or
                delete content and/or features, in any shape, form or way, for
                any or no reason.
              </p>
              <p>
                You agree that no content of information from this website would
                be duplicated, transferred, circulated or otherwise exploited in
                any way. You agree not to make any modifications or amendments
                to our work and further rent, lease, loan, sell, distribute,
                copy or make any derivative work which is based on this website
                (in any form or manner).
              </p>

              <br></br>
              <p>
                <strong>Submissions</strong>
              </p>
              <p>
                In terms of use, we use the word &#39;Submissions&#39; to mean
                messages, usernames, profiles, messages, photographs,
                appearances, biographical information or material, upload,
                display, communicate or otherwise distributed through our
                website. We may explicitly ask you to provide us during
                registrations for fantasy games.
              </p>

              <br></br>
              <p>
                <strong>Accounts</strong>
              </p>
              <p>
                Our website would require you to create a Member account on our
                website to get the required access to participate in fantasy
                games to access added features. You agree to provide us with,
                regularly maintain and keep updated, true, accurate, current and
                complete information about yourself, as may be asked during the
                registration process. You agree not to impersonate any other
                person or misrepresent your identity or affiliation with any
                person, entity or group (including, but not limited to, using
                someone else&#39;s name, username, password, image, account
                information).
              </p>
              <p>
                You understand, agree and acknowledge that we may take steps to
                ensure and verify that the information you have provided us with
                is true and correct.
              </p>
              <p>
                You agree to immediately inform us of any unauthorized use of
                your credentials (including, but not limited to, username,
                password) or any other breach of security which could be
                affecting the website or lead to an issue for the website.
              </p>
              <p>
                You agree that we would take actions (including, but not limited
                to, suspending or deleting your accounts), if you are found not
                adhering or complying to the above mentioned terms of use or for
                any other reasons in violation with our principles.
              </p>
              <br></br>
              <p>
                <strong>Public Forums and Communications</strong>
              </p>
              <p>
                Public Forum means an area of our website where we offer you
                features to make submissions which are open to viewing of one or
                multiple users or guests of our website (including, message,
                about you and your account profile).
              </p>
              <p>
                You understand and acknowledge that such public forum are not
                for private communications and any information (personal or
                otherwise) shared would be available to all the people using
                that forum, and the information could be misused by people known
                to you. We cannot guarantee or safeguard the security of the
                privacy of the information you disclose via such mediums, and
                all such disclosures are made by you at your own risk. We
                recommend you to refrain from sharing any personal information
                (such as telephone, e- mail, address, bank account information)
                or of anyone else through the public forums.
              </p>
              <p>
                We do not endorse any of the comments made by any user or guest
                on the public forum and we disclaim any or all liabilities in
                relation to it. We make no claims on the reliability of the
                information being shared on the public forums and can in no way
                be held responsible for any information that is being shared or
                made available by other users. We suggest you to refrain from
                relying on any such information to make any decisions for
                yourself or others.
              </p>
              <p>
                We reserve the right to screen content, refuse posting of
                content, edit submissions at any or all times, for any or no
                reason (including, but not limited to, non-compliance to the
                rules of conduct) at our sole discretion without any prior
                notice. We are not bound by duty to monitor such public forum,
                we at our sole discretion can choose to screen submissions,
                which could lead to a delay in the posting of that content on
                our website.
              </p>
              <p>
                We do not represent any of our partner clubs, leagues,
                associations, partners or sponsors in an official or unofficial
                capacity. We only provide each of these entities with a forum to
                facilitate a fantasy game, showcase products and services or
                advertise their own businesses. The information about each
                entity is as it is provided and we do not in anyway, shape or
                form, responsible for its authenticity, however, we endeavour to
                remain vigilant and share authentic and relevant information at
                all times.
              </p>
              <br></br>
              <p>
                <strong>Rules of Conduct</strong>
              </p>
              <p>
                By using this website, you consent and agree that you shall not
                distribute any submission that:
              </p>
              <ol>
                <li>
                  <p>
                    is abusive, threatening, defamatory, derogatory, hateful,
                    racially offensive, vulgar, obscene, pornographic or
                    sexually explicit, violent; or otherwise harmful to any
                    person or group;
                  </p>
                </li>
                <li>
                  <p>
                    infringes or violates our or any third-party’s right to (but
                    not limited to) intellectual property, copyrights,
                    trademarks, logos, service marks or disseminate information
                    on behalf of them in public, without our or the concerned
                    third-party&#39;s consent;
                  </p>
                </li>
                <li>
                  <p>makes any falsifying or misleading claims;</p>
                </li>
                <li>
                  <p>
                    is illegal or encourages or advocates illegal activities or
                    discussions leading to any criminal activity;
                  </p>
                </li>
                <li>
                  <p>
                    is marketable, related to business or advertises to sell any
                    service or product (charitable or otherwise);
                  </p>
                </li>
                <li>
                  <p>
                    attempts to make unauthorized access, other than the
                    permissions you have been granted for fair use of our
                    website;
                  </p>
                </li>
                <li>
                  <p>
                    attempts to harm or disrupt the website by introducing (but
                    not limited to) virus, malware, spam, tamper with the
                    website and/or connected network which infringes on the
                    other person&#39;s use of this website;
                  </p>
                </li>
                <li>
                  <p>
                    is not conforming of the discussion topic or theme of the
                    available public forum.
                  </p>
                </li>
                <li>
                  <p>
                    MyClubtap reserves all rights (without any warning) to
                    investigate and/or remove any persons individual team or
                    club from accessing its website (and servers) and/or
                    blocking the concerned accounts, if we at our sole
                    discretion have substantiate information on you violating
                    any of these laid terms of use, privacy policy and/or any
                    application laws.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>Support; Removal of Submissions</strong>
              </p>
              <p>
                We reserve the right, but disclaim any obligation or
                responsibility, to (a) refuse to post or communicate or remove
                any submissions made on this website that violates these terms
                of use, (b) provide any identifiable personal information to any
                third-party, and/or disclose any such information, when we
                believe in good faith that it (i) helps and facilitates the law,
                (ii) helps enforce these terms of use, our fantasy games rules,
                and/or protect the security of any person or property (including
                this website). In our sole discretion, we retain all rights to
                remove any submissions made by anyone on our website for any
                reason or no reason. You agree to report any submissions not
                conforming to these terms of use to us via e-mail on
                admin@myclubtap.com, following such a report, we may (but shall
                not be obliged to) take actions we consider appropriate in our
                sole discretion.
              </p>

              <br></br>
              <p>
                <strong>Disclaimers</strong>
              </p>
              <p>
                All content and information provided on this website is
                &#39;AS-IS&#39; and we give no warranty of any kind related to
                it. Without limiting the preceding, we make no warranty on the
                uninterrupted availability of the website, being error-free or
                absolutely secured. We explicitly deny any warranties of
                non-infringement or merchandise. You acknowledge that you are
                using our website at your own risk and agree that &#39;WE&#39;
                (i.e. MyClubtap), are in no way responsible or liable for any
                loss to your personal computer machine or software. You agree
                and understand the risks involved in accessing third-party links
                or content or making any submissions to them and that
                &#39;WE&#39; (MyClubtap) are in no way responsible or can be
                held liable for any loss occurring from your use of it.
              </p>

              <br></br>
              <p>
                <strong>Responsibility for Your Account(s)</strong>
              </p>
              <p>
                You are accountable to maintain the confidentiality of your
                personal account details (including, but not limited to,
                username(s), password(s)) and all activities undertaken within
                your account(s).
              </p>
              <p>
                You hereby agree to indemnify, defend and hold us (including,
                but not limited to, MyClubtap, agents, representatives, other
                authorized users, service providers, directors, owners) harmless
                from and against any and all losses, damages, liabilities,
                claims, fines, penalties, expenses and costs (legal, settlement,
                fees) incurred by the above mentioned parties in connection with
                any claims coming from your breach of these terms of use or your
                use of your account on this website. You shall use your best
                efforts to work together with us in the defence of any such
                claims. We reserve the right, at our own expense, to seek
                separate counsel on any matters deemed necessary.
              </p>

              <br></br>
              <p>
                <strong>Limitation of Liability</strong>
              </p>
              <p>
                We are in no way liable for any damage (including, but not
                limited to, personal damage or loss, material damage or loss),
                costs or expenses caused to any individual or group, suffered in
                relation to the use of our website (not limited to, but based on
                assurance or neglect). We will not accept any liability for any
                damages caused as a result of failure in the performance of an
                agreement, unlawful act or any other reason, including, but not
                limited to any loss occurring from the use of our website. We
                are in no way liable for any delay or failure to comply with our
                obligations under the terms of use, if it is caused due to
                reasons beyond our reasonable control (including, but not
                limited to, act of network provides or third-party
                applications).
              </p>

              <br></br>
              <p>
                <strong>Law and Jurisdiction</strong>
              </p>
              <p>
                These terms of use shall be governed by and constructed in
                accordance with the Australian law. You hereby consent that the
                courts of Melbourne in Victoria, Australia shall have exclusive
                jurisdiction in relation to any actions or claims made under
                these terms of use.
              </p>
              <p>
                We do not make any representation that the content or
                information made available on our website (includes any
                submissions made) are appropriate or available for use at any
                particular geographical location. You choose to access the
                website at your own will and are responsible to adhere to all
                laws (includes any local laws).
              </p>

              <br></br>
              <p>
                <strong>Amendment to these Terms of Use</strong>
              </p>
              <p>
                In our sole discretion, we reserve the right to add, delete,
                change or modify portions of these terms of use at any time
                without notice and that you are responsible to review these
                terms of use periodically to ensure you are updated of any
                changes made. Your continued use of this website after any
                modification of these terms of use will indicate and establish
                your consent to and acceptance of the modified terms of use.
              </p>
              <br></br>
              <p>
                <strong>Termination</strong>
              </p>
              <p>
                The listed terms of use are in effect until terminated by either
                us or by you. By stopping the use of this website and destroying
                all materials obtained from this website, you may terminate
                these terms of use at any time.
              </p>
              <p>
                We may terminate these terms of use with immediate effect
                (including your access to our website) in our absolute
                discretion, without limitation, if you are found in breach of
                (includes fraudulent information, use of abusive terms or
                language or other illegal activities) or have failed to comply
                with any terms or provisions of these terms of use. You would be
                required to immediately destroy any material collected by you
                from our website (irrespective of whether they are made under
                these terms of use or otherwise).
              </p>
              <br></br>
              <p>
                <strong>Privacy Policy</strong>
              </p>
              <p>
                We may ask submissions on our website through features, e.g.
                fantasy games or public forums. If we ask and you provide us
                with personally identifiable as part of any submissions
                (excluding public forums, you can choose &#39;to&#39; or
                &#39;not to&#39; disclose personal information), our privacy
                policy will usually apply (as specified on the website). Please
                see our Privacy Policy for further information on the way we
                collect and store any personal information you provide us while
                using our website.
              </p>

              <br></br>
              <p>
                <strong>Delivery Policy</strong>
              </p>
              <p>
                We are not responsible for delivery of any Product you order
                with MyClubtap Partners. Product delivery is the sole
                responsibility of the concerned partner.
              </p>

              <br></br>
              {/* COndition of use section finish here */}
              <p>
                <strong>Acknowledgement : Icons - Features, Pricing</strong>
              </p>
              <ol>
                <li>
                  <p>
                    Icons made by&nbsp;
                    <a href="https://www.flaticon.com/authors/freepik">
                      Freepik
                    </a>
                    &nbsp;from&nbsp;
                    <a href="http://www.flaticon.com/" target="_blank">
                      www.flaticon.com
                    </a>
                    .
                  </p>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermCondition;
